import { CustomAction } from '../model/state';
import { CommonPayload } from '../actions/Common';
import { MessageState } from '../model/state/MessageState';
import { MessageType } from '../model/Message';
import { SHOW_MESSAGE, CLEAR_MESSAGE } from 'constants/ActionTypes';

const initialState: MessageState = {
  type: MessageType.INFO,
  message: null,
  description: null
};

function messageReducer(state: MessageState | undefined = initialState, action: CustomAction<CommonPayload>) {
  switch (action.type) {
    case SHOW_MESSAGE:
      return {
        ...state,
        ...action.payload?.message
      }

    case CLEAR_MESSAGE:
      return {
        ...state,
        message: null,
        description: null
      }

    default:
      return state
  }
}

export default messageReducer;
